import Vue from 'vue' ;
import { Component } from 'vue-property-decorator' ;
import { namespace } from 'vuex-class' ;
import { USER_MODULE_NAMESPACE, USER_INFO_UPDATE } from '../../../store/user/user-types.store';
import { IUserDetails } from '../../../models/user';
import { UPDATE_ACCOUNT_PROFILE_FUNC } from '../../../common/constants';


const UserStore= namespace(USER_MODULE_NAMESPACE)

@Component({
    components:{
        'profile-update-modal': async () => import('../components/profile-update-modal/ProfileUpdateModal.vue'),
        'profile-child-account': async () => import('../profile-child-account/ProfileChildAccount.vue'),
        'profile-child-notification': async () => import('../profile-child-notification/ProfileChildNotification.vue')
    }
})
class ProfileChild extends Vue {

    dtTitle: string;
    modal: any;
    loadUpdateAccount: boolean;
    loadUpdateImage: boolean
    loadUpdateNotifications: boolean
    snackbar: { open: boolean, timeout: number, text: string, color: string };

    constructor(){
        super()
        this.dtTitle= null
        this.modal = {
            display: false,
            title: '',
            msg: '',
            save: () => { },
            params: {}
        };
        this.loadUpdateAccount = false;
        this.loadUpdateImage= false
        this.loadUpdateNotifications= false
        this.snackbar = {
            open: false,
            timeout: 3000,
            text: '',
            color: 'primaryDark'
        }
    }

    @UserStore.Getter userInfo : IUserDetails

    @UserStore.Action(USER_INFO_UPDATE)
    storeUpdateUserInfo: (payload: any) => Promise<any>;

    get lblSetting(){
        return {
            ...require('../../../locales/profile').default,
            ...require('../../../locales/button').default,
            ...require('../../../locales/generic-labels').default,
            ...require('../../../locales/validation-messages').default
        }
    }

    get coTitlePrefix(): string {
        let fn = (this.userInfo.firstname || '');
        let ln = (this.userInfo.lastname || '');
        let ci = (this.userInfo.civility_shorten || '');
        this.dtTitle = `${ci} ${fn} ${ln}`;
        return `${fn.substring(0, 1)}${ln.substring(0, 1)}`;
    }

    [ UPDATE_ACCOUNT_PROFILE_FUNC ]
    (payload) {
        this.loadUpdateAccount = true;
        this.closeModal();
        this.storeUpdateUserInfo(payload)
          .then((response) => {
            this.loadUpdateAccount = false;
            this.displaySnackBar(this.$t(this.lblSetting.profileUpdated), 'primaryDark')
          })
          .catch((error) => {
            console.log(error);
            this.loadUpdateAccount = false;
            this.displaySnackBar(this.$t(this.lblSetting.lblErrorHappen), 'error')
          });
    }

    handleUpdateImage(fileUrl: string){
        this.loadUpdateImage= true
        this.storeUpdateUserInfo({picture: fileUrl})
          .then((response) => {
            this.loadUpdateImage = false;
            this.displaySnackBar(this.$t(this.lblSetting.preferenceUpdated), 'primaryDark')
          })
          .catch((error) => {
            console.log(error);
            this.loadUpdateImage = false;
            this.displaySnackBar(this.$t(this.lblSetting.lblErrorHappen, { type: 'Image' }), 'error')
          });
    }

    handleUpdateNotifications(params: any){
        this.loadUpdateNotifications= true
        this.storeUpdateUserInfo(params)
          .then(response=>{
            this.loadUpdateNotifications = false;
            this.displaySnackBar(this.$t(this.lblSetting.preferenceUpdated), 'primaryDark')
          })
          .catch(err=> {
            console.log(err);
            this.loadUpdateNotifications = false;
            this.displaySnackBar(this.$t(this.lblSetting.lblErrorHappen, { type: 'Notifications' }), 'error')
          })
    }

    displayModal(title, msg, save, params) {
        /*this.modal.display = true;
        this.modal.title = title;
        this.modal.msg = msg;
        this.modal.save = this[ save ];
        this.modal.params = params;*/
        this[ save ](params)
    }

    displaySnackBar(text, color?, timeout?) {
        this.snackbar.open = true;
        this.snackbar.text = text;
        this.snackbar.color = color || this.snackbar.color;
        this.snackbar.timeout = timeout || this.snackbar.timeout;
    }

    closeModal() {
        this.modal.display = false;
        this.modal.title = '';
        this.modal.msg = '';
        this.modal.save = () => { };
        this.modal.params = {};
    }
}

export default ProfileChild


// WEBPACK FOOTER //
// ./src/containers/profile/profile-child/index.ts